import Box, { BoxProps } from '@mui/material/Box';
import Divider, { DividerProps } from '@mui/material/Divider';
import Typography, { TypographyProps } from '@mui/material/Typography';

export const DividerWithText = ({
  text,
  align = 'center',
  slotProps = {},
}: {
  text: string;
  align?: 'left' | 'center' | 'right';
  slotProps?: {
    leftDivider?: Partial<DividerProps>;
    rightDivider?: Partial<DividerProps>;
    text?: Partial<TypographyProps>;
    container?: Partial<BoxProps>;
  };
}) => (
  <Box
    {...slotProps?.container}
    sx={{
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      my: 1,
      ...slotProps?.container?.sx,
    }}
  >
    <Divider
      sx={{
        flexGrow: 1,
        borderColor: 'text.secondary',
        maxWidth: align === 'left' ? 12 : 'unset',
        ...slotProps?.leftDivider?.sx,
      }}
      {...slotProps?.leftDivider}
    />
    <Typography
      variant="overline"
      sx={{
        mx: 2,
        whiteSpace: 'nowrap',
        color: 'text.secondary',
        display: 'inline-block',
        ...slotProps?.text?.sx,
      }}
      {...slotProps?.text}
    >
      {text}
    </Typography>
    <Divider
      sx={{
        flexGrow: 1,
        borderColor: 'text.secondary',
        maxWidth: align === 'right' ? 12 : 'unset',
        ...slotProps?.rightDivider?.sx,
      }}
      {...slotProps?.rightDivider}
    />
  </Box>
);
